"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OPERATORS_BY_PREDICATE_TYPE = exports.ContextCapabilitiesError = exports.CONTEXT_PREDICATE_TYPES = exports.CONTEXT_OPERATOR_KEYS = exports.CONTEXT_OPERAND_TYPES = exports.CONTEXT_NETWORK_SCOPE_ANY = exports.CONTEXT_CAPABILITIES_VERSION = void 0;
exports.parseContextFilterCapabilities = parseContextFilterCapabilities;
const CONTEXT_OPERATOR_KEYS = exports.CONTEXT_OPERATOR_KEYS = ['equals', 'in', 'contains', 'starts_with', 'ends_with', 'matches_regex', 'contains_all', 'within', 'within_any'];
const CONTEXT_PREDICATE_TYPES = exports.CONTEXT_PREDICATE_TYPES = ['identity', 'string', 'labels', 'ip'];
const CONTEXT_OPERAND_TYPES = exports.CONTEXT_OPERAND_TYPES = ['string', 'ip', 'cidr'];
const OPERATORS_BY_PREDICATE_TYPE = exports.OPERATORS_BY_PREDICATE_TYPE = {
  identity: ['equals', 'in'],
  string: ['equals', 'in', 'contains', 'starts_with', 'ends_with', 'matches_regex'],
  labels: ['equals', 'in', 'contains_all'],
  ip: ['equals', 'in', 'within', 'within_any']
};
const CONTEXT_CAPABILITIES_VERSION = exports.CONTEXT_CAPABILITIES_VERSION = 1;
const CONTEXT_NETWORK_SCOPE_ANY = exports.CONTEXT_NETWORK_SCOPE_ANY = 'NETWORK_SCOPE_ANY';
class ContextCapabilitiesError extends Error {
  constructor(message) {
    super(`Invalid context filter capabilities: ${message}`);
    this.name = 'ContextCapabilitiesError';
  }
}
exports.ContextCapabilitiesError = ContextCapabilitiesError;
const isRecord = value => typeof value === 'object' && value !== null && !Array.isArray(value);
const requireKey = (value, what) => {
  if (typeof value !== 'string' || value.trim() === '') {
    throw new ContextCapabilitiesError(`${what} must be a nonempty string`);
  }
  return value;
};
function validateOperator(raw, field, seen) {
  if (!isRecord(raw)) {
    throw new ContextCapabilitiesError(`operator of "${field.key}" must be an object`);
  }
  const key = raw.key;
  if (!CONTEXT_OPERATOR_KEYS.includes(key)) {
    throw new ContextCapabilitiesError(`unsupported operator "${String(raw.key)}" on "${field.key}"`);
  }
  if (seen.has(key)) {
    throw new ContextCapabilitiesError(`duplicate operator "${key}" on "${field.key}"`);
  }
  seen.add(key);
  if (!OPERATORS_BY_PREDICATE_TYPE[field.predicateType].includes(key)) {
    throw new ContextCapabilitiesError(`operator "${key}" is not valid for a ${field.predicateType} field`);
  }
  if (!isRecord(raw.operand)) {
    throw new ContextCapabilitiesError(`operator "${key}" on "${field.key}" is missing its operand`);
  }
  const operandType = raw.operand.type;
  if (!CONTEXT_OPERAND_TYPES.includes(operandType)) {
    throw new ContextCapabilitiesError(`operator "${key}" on "${field.key}" has an unsupported operand type`);
  }
  if (typeof raw.operand.multiple !== 'boolean') {
    throw new ContextCapabilitiesError(`operator "${key}" on "${field.key}" must declare operand cardinality`);
  }
  return {
    key,
    operand: {
      type: operandType,
      multiple: raw.operand.multiple
    }
  };
}
function validateField(raw, seen) {
  if (!isRecord(raw)) {
    throw new ContextCapabilitiesError('each field must be an object');
  }
  const key = requireKey(raw.key, 'field key');
  if (seen.has(key)) {
    throw new ContextCapabilitiesError(`duplicate field "${key}"`);
  }
  seen.add(key);
  const predicateType = raw.predicateType;
  if (!CONTEXT_PREDICATE_TYPES.includes(predicateType)) {
    throw new ContextCapabilitiesError(`unsupported predicate type on "${key}"`);
  }
  if (typeof raw.supportsNegation !== 'boolean') {
    throw new ContextCapabilitiesError(`"${key}" must declare negation support`);
  }
  if (!Array.isArray(raw.operators) || raw.operators.length === 0) {
    throw new ContextCapabilitiesError(`"${key}" must offer at least one operator`);
  }
  const field = {
    key,
    predicateType,
    supportsNegation: raw.supportsNegation,
    operators: []
  };
  const seenOperators = new Set();
  field.operators = raw.operators.map(operator => validateOperator(operator, field, seenOperators));
  return field;
}
function parseContextFilterCapabilities(raw) {
  if (!isRecord(raw)) {
    throw new ContextCapabilitiesError('response must be an object');
  }
  if (raw.version !== CONTEXT_CAPABILITIES_VERSION) {
    throw new ContextCapabilitiesError(`unsupported version ${String(raw.version)}`);
  }
  if (!Array.isArray(raw.networkScopes)) {
    throw new ContextCapabilitiesError('networkScopes must be an array');
  }
  if (!Array.isArray(raw.fields)) {
    throw new ContextCapabilitiesError('fields must be an array');
  }
  const seenScopes = new Set();
  const networkScopes = raw.networkScopes.map(scope => {
    if (!isRecord(scope)) {
      throw new ContextCapabilitiesError('each network scope must be an object');
    }
    const value = requireKey(scope.value, 'network scope value');
    if (seenScopes.has(value)) {
      throw new ContextCapabilitiesError(`duplicate network scope "${value}"`);
    }
    seenScopes.add(value);
    return {
      value
    };
  });
  const seenFields = new Set();
  const fields = raw.fields.map(field => validateField(field, seenFields));
  if (fields.length > 0 && !seenScopes.has(CONTEXT_NETWORK_SCOPE_ANY)) {
    throw new ContextCapabilitiesError(`a nonempty catalog must support ${CONTEXT_NETWORK_SCOPE_ANY}`);
  }
  return {
    version: CONTEXT_CAPABILITIES_VERSION,
    networkScopes,
    fields
  };
}